
import { useEffect } from "react"
import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import { Alert } from "@material-ui/lab";
import { useSelector, useDispatch } from "react-redux";
import { formatDinero } from "./../../../../utils/formatDinero"
import { obtenerGrupoViajeUtilidad } from "./../../../../ducks/clientesDuck"
const columns = [
    { id: "cv", minWidth: 50, align: "center", label: "Clave de viaje" },
    { id: "np", minWidth: 50, align: "center", label: "Nombre paquete" },
    { id: "td", minWidth: 50, align: "center", label: "Total depositos" },
    { id: "tp", minWidth: 50, align: "center", label: "Total proveedor" },
    { id: "tu", minWidth: 50, align: "center", label: "Total utilidad" },
]

const useStyles = makeStyles({
    containerRoot: {
        marginTop: "25px",
    },
    containerRootButton: {
        marginTop: "25px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    root: {
        width: '100%',
        padding: '0'
    },
    container: {
        maxHeight: 440,
    },
})

const TablaCompras = () => {
    const { grupoViajeUtilidad, referencia, cliente } = useSelector(store => store.cliente)
    const classes = useStyles()
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(obtenerGrupoViajeUtilidad({ ClaveViaje: cliente?.paquete?.ClaveViaje }))
    }, [dispatch, cliente?.paquete?.ClaveViaje])
    if (referencia === "")
        return (
            <div className="TarjetaClienta-root">
                <div className="contenido">
                    <Alert className="alerta" severity="info">Selecciona un cliente</Alert>
                </div>
            </div>
        )

    return (
        <div className={classes.containerRoot}>
            <Paper className={classes.root}>
                <TableContainer className={classes.container}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow hover role="checkbox">
                                <TableCell align='center'>
                                    {cliente?.paquete?.ClaveViaje}
                                </TableCell>
                                <TableCell align='center'>
                                    {grupoViajeUtilidad?.NombrePaquete}
                                </TableCell>
                                <TableCell align='center'>
                                    {`${formatDinero(grupoViajeUtilidad?.TotalDepositado)} ${grupoViajeUtilidad?.MonedaPaquete?.Clave}`}
                                </TableCell>
                                <TableCell align='center'>
                                    {`${formatDinero(grupoViajeUtilidad?.TotalProveedor)} ${grupoViajeUtilidad?.MonedaProveedor?.Clave}`}
                                </TableCell>
                                <TableCell align='center'>
                                    {`${formatDinero(grupoViajeUtilidad?.TotalUtilidad)} ${grupoViajeUtilidad?.MonedaProveedor?.Clave}`}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </div>
    )
}
export default TablaCompras